import { Route } from "react-router-dom";
import ReservationsPrepaidBookingsReportScreen from "../../../container/Reservations/ReservationsPrepaidBookingsReportScreen";
import CreateReservationsPrepaidBookingsReport from "../../../container/Reservations/ReservationsPrepaidBookingsReportScreen/CreateReservationsPrepaidBookingsReport";
import { APP_URLS } from "../../../utils/constant";

const ReservationsPrepaidBookingsReportRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_PREPAIDBOOKINGSREPORT.HOME}
          element={
            <ReservationsPrepaidBookingsReportScreen
              screenPermissions={access}
            />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RESERVATIONS_PREPAIDBOOKINGSREPORT.CREATE}
          element={<CreateReservationsPrepaidBookingsReport />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RESERVATIONS_PREPAIDBOOKINGSREPORT.EDIT}
          element={<CreateReservationsPrepaidBookingsReport isEdit={true} />}
        />
      )}
    </>
  );
};

export default ReservationsPrepaidBookingsReportRoutes;
